import { Router } from '@reach/router';
import React from 'react';

import Loading from '$/components/Loading';
import { PlayerMode } from '$/components/WebinarPlayer/types';
import { LazyRoute } from '$/components/LazyRoute';
import Register from './Registration/RegistrationPages';

const PublicAnalytics = React.lazy(
  () => import('$/sections/Home/Dashboard/Analytics/PublicAnalytics')
);

const EmbeddedPlayer = React.lazy(() => import('$/components/EmbeddedPlayer/EmbeddedPlayer'));
const ViewWebinar = React.lazy(() => import('$/sections/PublishedWebinar/ViewWebinar/ViewWebinar'));
const TestWebinar = React.lazy(() => import('$/sections/PublishedWebinar/ViewWebinar/TestWebinar'));

const Unsubscribe = React.lazy(() => import('$/sections/PublishedWebinar/Unsubscribe'));

const PublishedWebinarRouter: React.FC = () => {
  return (
    <Router>
      <LazyRoute Component={PublicAnalytics} path='/webinar/:setId/analytics/:token' />
      <LazyRoute Component={TestWebinar} path='/webinar/:setId/test/*attendeeId/*' />
      <LazyRoute
        Component={ViewWebinar}
        mode={PlayerMode.live}
        path='/webinar/:setId/join/*attendeeId/*'
      />
      <LazyRoute
        Component={ViewWebinar}
        mode={PlayerMode.replay}
        path='/webinar/:setId/replay/*attendeeId/*'
      />
      <LazyRoute Component={EmbeddedPlayer} path='/webinar/:setId/embedded/:mode' />
      <LazyRoute Component={Unsubscribe} path='/webinar/:setId/unsubscribe/:attendeeId' />
      <Register path='/webinar/:setId/*' />
      <LazyRoute Component={Loading} path='/webinar/' />
    </Router>
  );
};

export default PublishedWebinarRouter;
